import { createRouter, createWebHistory } from 'vue-router'
import qs from 'qs'
import { routes } from './routes'
import { useUserStore } from '@/lib/store/user'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
	parseQuery: qs.parse,
	stringifyQuery: qs.stringify,

})

// router.beforeEach(async (to, from, next) => {
// 	console.log({to, })
// 	const userStore = useUserStore()

// 	let user = userStore.me
// console.log('[router] a', { user }, to.name, to.matched[0]?.name)
// 	if (!user) {
// 		try {
// 			user = await userStore.checkUser()
// console.log('[router] b', { user }, to.name, to.matched[0]?.name)

// 		} catch (error) {
// console.log('[router] c', { error }, to.name, to.matched[0]?.name)

// 			user = null
// 			if (to.name != 'login') {
// 				if (to.matched[0]?.name == 'public') {
// 					return next()
// 				}

// 				return next({ name: 'login'})
// 			}
// 		}
// 	}

// 	if (to.matched[0]?.name == 'public') {
// 		// Main page
// 		if (!to.matched[1]) {
// 			if (user) {
// 				return next({ name: 'calculator' })
// 			}
// 		}
// 		return next()
// 	} else {
// 		if (user && !userStore.token?.claims?.tenantId) {
// 			return next({ name: 'interstitial' })
// 		}
// 	}

// 	return next()
// })

export default router
